import { Mark } from 'tiptap'

export default class Deluxe extends Mark {
  get name() {
    return 'deluxe'
  }

  get schema() {
    return {
      parseDOM: [
        {
          tag: 'span.pm-deluxe',
        },
      ],
      toDOM: () => ['span', { class: 'pm-deluxe' }, 0],
    }
  }
}
